import clientSide from './clientSide';
import { getCookie, setCookie } from '~/helpers/cookie';

// Checks to see if the user has a spanish language in their top 3 preferred languages or if they have the ljs=es-US query parameter in the URL
export function spanishPreferred(): Array<string> | boolean {
  if (clientSide) {

    const languagesArray = [...navigator?.languages];

    const searchParams = new URLSearchParams( window.location?.search || '' );
    const ljs = searchParams.get('ljs');

    // standardize capitalization for query string
    const lowercaseLjs = ljs?.toLowerCase();

    // prefersSpanish is true if the user has a spanish language in their top 3 preferred languages,
    // the query parameter ljs=es-US or ljs=es-us,
    // or the cookie localizeLanguage already set
    const prefersSpanish = languagesArray.slice( 0, 3 ).some( ( language ) => language.includes( 'es' ) ) ||
    lowercaseLjs === 'es-us' || getCookie('localizeLanguage')?.toLowerCase() === 'es-us';

    // Add localizeLanguage cookie if the user prefers Spanish for autotranslate
    if ( prefersSpanish ) setCookie('localizeLanguage', 'es-US');

    return prefersSpanish;
  }

  return false;
}
